import { isTelegram } from '../telegram/detect';

const APP_URL = 'https://t.me/recipt_help_Bot/app';
export type ShareResult = 'telegram' | 'shared' | 'copied' | 'failed';

// Отправляет готовый текст наружу. В Telegram — нативный «Поделиться» (выбор чата,
// можно переслать жене). Вне — системный share, иначе буфер обмена.
export async function shareShoppingText(text: string): Promise<ShareResult> {
  if (!text) return 'failed';
  const wa = typeof window !== 'undefined' ? window.Telegram?.WebApp : undefined;
  if (isTelegram() && wa?.openTelegramLink) {
    const url = `https://t.me/share/url?url=${encodeURIComponent(APP_URL)}&text=${encodeURIComponent(text)}`;
    wa.openTelegramLink(url);
    return 'telegram';
  }
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
      await navigator.share({ text });
      return 'shared';
    }
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return 'copied';
    }
  } catch {
    return 'failed';
  }
  return 'failed';
}

// Явное копирование (кнопка «Скопировать»). true — успех.
export async function copyText(text: string): Promise<boolean> {
  if (!text) return false;
  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch { /* ignore */ }
  return false;
}
